import React, { useState, useEffect } from 'react';
import ContentCopyIcon from '@mui/icons-material/ContentCopy';
import Tooltip from '@mui/material/Tooltip';
import IconButton from '@mui/material/IconButton';

export default ({ text }) => {
    const [open, setOpen] = useState(false);

    useEffect(() => {
        if (open) {
            setTimeout(() => setOpen(false), 3000);
        }
    }, [open]);

    const copyToClipboard = () => {
        navigator.clipboard.writeText(text);
        setOpen(true);
    };

    return (
        <Tooltip title='Copied!' open={open}>
            <IconButton
                aria-label='copy-to-clipboard'
                color='primary'
                disabled={!text}
                onClick={copyToClipboard}>
                <ContentCopyIcon />
            </IconButton>
        </Tooltip>
    );
};
